import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';

import { ENVIRONMENT } from '../../../../core/tokens/app.tokens';
import type { ISynthesisProvider, SpeechRequest } from './i-synthesis.provider';

@Injectable()
export class HttpSynthesisProvider implements ISynthesisProvider {
  private readonly http = inject(HttpClient);
  private readonly env = inject(ENVIRONMENT);

  synthesize(request: SpeechRequest): Observable<Blob> {
    return this.http.post(`${this.env.apiUrl}/speech/synthesis`, request, { responseType: 'blob' });
  }
}
